/**
 * Compute SHA-256 hash of a File using the Web Crypto SubtleCrypto API.
 * Returns the hex-encoded digest string.
 *
 * For large files the browser reads the entire ArrayBuffer into memory once,
 * which is fine for typical invoice files (< 50 MB). If we need streaming
 * later, we can swap to a chunked approach.
 */
export async function computeSha256(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}
